module.exports = __webpack_public_path__ + "img/hp-v4.a980f87b.svg";